import React from 'react';
import { Form, Input } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { ReferralTemplatesFormProps, whatsAppTemplatePlaceholders } from '../types';
import { createPlaceholdersValidatorRule, getPlaceholdersHint } from '../validators';
import ResetFieldButton from '../../../Common/ResetFieldButton';

const defaultValue = 'Dein Freund {{inviterName}} hat dich eingeladen! {{link}}';

const prefix: keyof ReferralTemplatesFormProps = 'whatsAppTemplate';

function WhatsAppTemplate() {
  const form = useFormInstance();

  const handleReset = () => {
    form.setFieldValue(prefix, defaultValue);
    form.validateFields([prefix]);
  };

  return (
    <Form.Item
      label={(
        <div className="centered-content">
          WhatsApp Template
          <ResetFieldButton onClick={handleReset} />
        </div>
      )}
      name={prefix}
      extra={getPlaceholdersHint(whatsAppTemplatePlaceholders)}
      rules={[createPlaceholdersValidatorRule(whatsAppTemplatePlaceholders)]}
    >
      <Input placeholder="Enter WhatsApp template text" maxLength={1000} showCount />
    </Form.Item>
  );
}

export default WhatsAppTemplate;
